export const NAME_VALIDATION = /^[a-zA-Z-'0-9\. ]*$/;
export const EMAIL_VALIDATION = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
